import { NexaAskRequest } from '../types/askNexa';

/**
 * In-memory store for pending Ask Nexa requests during navigation
 *
 * This store is used to pass request context from /nx/ask to /nexa/<sessionId>
 * without relying on router state (which persists on tab duplication).
 *
 * The store is automatically cleaned up after consumption to prevent memory leaks.
 */

type Store = {
  [sessionId: string]: NexaAskRequest | undefined;
};

const askNexaStore: Store = {};

/**
 * Store a pending Ask Nexa request for a given session ID
 *
 * @param sessionId - The session ID to associate with the request
 * @param req - The Ask Nexa request to store
 */
export const setPendingAskRequest = (sessionId: string, req: NexaAskRequest) => {
  askNexaStore[sessionId] = req;
};

/**
 * Consume a pending Ask Nexa request for a given session ID
 *
 * This function retrieves the request and immediately deletes it from the store
 * to ensure it's only used once and to prevent memory leaks.
 *
 * @param sessionId - The session ID to retrieve the request for
 * @returns The stored request, or null if none exists
 */
export const consumePendingAskRequest = (sessionId: string): NexaAskRequest | null => {
  const req = askNexaStore[sessionId] ?? null;
  delete askNexaStore[sessionId];
  return req;
};
